$('body').imagesLoaded({background: true}, function() {
    setTimeout(function() {
        $('body').addClass('loaded');
    }, 500);
});
